import { useEffect, useRef, type ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { staffText } from "@/lib/staff-language";
let scrollLocks=0;
let originalOverflow="";

export default function StaffModal({children,onClose,employee=false,wide=false,className="",ariaLabel}:{children:ReactNode;onClose:()=>void;employee?:boolean;wide?:boolean;className?:string;ariaLabel?:string}) {
  const closeRef=useRef(onClose);closeRef.current=onClose;
  const modalRef=useRef<HTMLDivElement>(null);
  const {i18n}=useTranslation();
  useEffect(()=>{
    const previous=document.activeElement as HTMLElement|null;
    const modal=modalRef.current;
    if(scrollLocks++===0){originalOverflow=document.body.style.overflow;document.body.style.overflow="hidden"}
    modalRef.current?.focus();
    const key=(e:KeyboardEvent)=>{
      const dialogs=document.querySelectorAll('[role="dialog"][aria-modal="true"]');
      if(dialogs.length&&dialogs[dialogs.length-1]!==modalRef.current)return;
      if(e.key==="Escape"){
         // The card's portaled action menu owns Escape before its dialog does.
         if(e.target instanceof Element&&e.target.closest(".staff-action-menu"))return;
        if(e.defaultPrevented)return;
        e.preventDefault();e.stopImmediatePropagation();closeRef.current();
      }
      if(e.key==="Tab"){
        const elements=modalRef.current?.querySelectorAll<HTMLElement>('button:not(:disabled),input:not(:disabled):not([hidden]),textarea:not(:disabled),select:not(:disabled),a[href],summary,[tabindex="0"]');
        if(!elements?.length)return;
        const first=elements[0],last=elements[elements.length-1];
        if(e.shiftKey&&(document.activeElement===first||document.activeElement===modalRef.current)){e.preventDefault();last.focus()}
        else if(!e.shiftKey&&(document.activeElement===last||document.activeElement===modalRef.current)){e.preventDefault();first.focus()}
      }
    };
    // Window capture runs before an underlying Radix Sheet's document Escape listener.
    window.addEventListener("keydown",key,true);
    return()=>{
      if(--scrollLocks===0)document.body.style.overflow=originalOverflow;
      window.removeEventListener("keydown",key,true);
      const dialogs=document.querySelectorAll<HTMLElement>('[role="dialog"][aria-modal="true"]');
      const top=Array.from(dialogs).filter(d=>d!==modal).at(-1);
      if(previous?.isConnected&&(!top||top.contains(previous)))previous.focus();
      else top?.focus();
    };
  },[]);
  return <div className="ov" id={employee?"empOv":undefined} onClick={e=>{if(e.target===e.currentTarget)onClose()}}><div ref={modalRef} className={`md staff-modal${employee||wide?" wide":""} ${className}`} role="dialog" aria-modal="true" aria-label={ariaLabel} tabIndex={-1}><button type="button" className="x" aria-label={staffText("Close",i18n.language==="ar")} onClick={onClose}>×</button>{children}</div></div>;
}
